// Module
var code = "<div class=\"block-9__image image\"></div> ";
// Exports
export default code;